export const MODALS_ROOT_ID = 'modals-root'

export const getModalsRootElement = () => document.getElementById(MODALS_ROOT_ID)